export default {
    computed: {
        answers() {
            return this.$store.state.answers;
        }
    },

    mounted() {
        this.initialize();
    },

    methods: {
        openNextQuestion(stepId, questionId) {
            this.$nextTick(() => {
                let next = $('#header-' + stepId + 'Question' + questionId).parents('.card-container')
                    .first()
                    .next();
                if (next.length != 0) {
                    next.find('[data-toggle="collapse"]')
                        .click();
                } else {


                    $('#header-' + stepId + 'Question' + questionId).parents('.card-container')
                        .first().find('[data-toggle="collapse"].collapsed')
                        .click();
                }
            });
        }
    }
}